// extracted by mini-css-extract-plugin
export default {"root":"Title_root__WaqiI","h1":"Title_h1__8LBMQ","h2":"Title_h2__f06vK","h3":"Title_h3__juOEs","h4":"Title_h4__3xNE8","h5":"Title_h5__sZG7s"};